export const types = {
  SET_CONTROLS: "SET_CONTROLS",
  SET_FLAGS: "SET_FLAGS",
};

export default {
  [types.SET_CONTROLS]: (state, controls) => {
    state.controls = controls;
  },

  [types.SET_FLAGS]: (state, flags) => {
    state.flags = flags;
  },
};
